import { render } from "./user-bookings.vue?vue&type=template&id=ccd60c9c"
import script from "./user-bookings.vue?vue&type=script&lang=js"
export * from "./user-bookings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__